import { useState, useEffect } from "react";
import "./testimonial.css";

const testimonials = [
  { quote: "Reliable, professional and fairly priced. They fixed multiple issues quickly and neatly. Highly recommended.", author: "Daniel P from Hawthorn" },
  { quote: "Honest advice, clean work, and a beautiful result for our laundry renovation. Very happy!", author: "Emily W from Glen Iris" },
  { quote: "The team was punctual and professional. The results exceeded our expectations!", author: "Mark W from Oakleigh" },
  { quote: "Competitive pricing, Great communication, high quality work. Thanks again Interior 4U!", author: "Lak H from Mount Waverley"},
]

const Testimonial = () => {
    const [index, setIndex] = useState(0);
    
      useEffect(() => {
        const interval = setInterval(() => {
          setIndex((prev) => (prev + 1) % testimonials.length);
        }, 4000);
        return () => clearInterval(interval);
      }, []);

    return (
        <div className="testimonial">
            <div className="testimonial-inner">
                <p className="testimonial-quote">“{testimonials[index].quote}”</p>
                <p className="testimonial-author">- {testimonials[index].author}</p>
            </div>

            <div className="testimonial-dots">
                {testimonials.map((_, i) => (
                <button
                    key={i}
                    className={`dot ${i === index ? 'active' : ''}`}
                    onClick={() => setIndex(i)}
                    aria-label={`Go to testimonial ${i + 1}`}
                />
                ))}
            </div>
        </div>
    )
}

export default Testimonial;